var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__container-inner"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.getCurUrl,"width":"100%","height":"475","loading":"lazy","frameborder":"0","allowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }